import { render, staticRenderFns } from "./FinalizeAuth.vue?vue&type=template&id=24b683a6"
import script from "./FinalizeAuth.vue?vue&type=script&lang=js"
export * from "./FinalizeAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports